// extracted by mini-css-extract-plugin
module.exports = {"button":"SmartInvestVideo-module__button___VgJbf","buttonReplay":"SmartInvestVideo-module__buttonReplay___2ujSD"};